<style>
#applicationsRegister .v--modal-box.v--modal {
  min-height: 350px !important;
  min-width: 600px !important;
}
#applicationsRegister .modal__footer {
  display: none !important;
}
</style>

<template>
  <Modal
    modalName="applicationsRegister"
    title="Rejestr wniosków"
    :buttons="[]"
  >
    <ApplicationsTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import ApplicationsTable from "../../table/investments/ApplicationsTable.vue";

export default {
  components: {
    Modal,
    ApplicationsTable
  },
  data: () => ({
  }),
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/management/modals/ApplicationsRegister.vue